/**
 * Central place for client-visible configuration (Vite `import.meta.env`).
 * Do not put secrets here; anything prefixed with VITE_ is bundled for the browser.
 */
export const env = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  /** Base URL for Olive API (no trailing slash required). */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  /** Admin-host Cognito settings (required when hostname starts with `admin.`). */
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
  cognitoAppClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID ?? "",
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN ?? "",
} as const;
